import PropTypes from 'prop-types';
// material
import { Box, Modal, Typography, Button } from '@mui/material';
// ------------------------------------------------------------------------------------------------

ErrorBMsgPopup.propTypes = {
    confirm: PropTypes.func,
    msg: PropTypes.string,
    header: PropTypes.string,
};
// ------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    bgcolor: 'background.paper',
    borderRadius: 1.5,
    p: 4,
    width: 390,
    height: 'auto'
}
// ------------------------------------------------------------------------------------------------

export default function ErrorBMsgPopup({ confirm, msg, header }) {

    const onClickYes = (event) => {
        confirm(true);
    };

    return (
        <div>
            <Modal open >   
                <Box sx={style} >
                    <Typography variant='h5' alignItems='left'>
                        {header}
                    </Typography>
                    <Typography variant='body1' alignItems='center' sx={{ mt: 3 ,mb:5 }}>
                        {msg}
                    </Typography>

                    <Box sx={{ position: 'absolute', bottom: 16, right: 16 }} >
                        <Button type="submit" variant="contained" onClick={onClickYes} > Ok </Button>
                    </Box>
                </Box>

            </Modal>
        </div >
    )
}